<script>
export default {
  name: 'KyeReportArrow',
  props: {
    type: {
      type: String,
      default: ''
    },
  },
  computed: {
    arrowIcon() {
      switch (this.type) {
        case 'up':
          return 'layout-report-new-up'
        case 'down':
          return 'layout-report-new-down'
        case 'stable':
          return 'layout-report-new-stable'
        default:
          return ''
      }
    }
  },
  render () {
    return this.$props.type ? (<i
    on-click={this.arrowClick}
    class={['layout', 'kye-report-arrow', this.arrowIcon]}
   />) : <i style="display:none"></i>
  },
  methods: {
    arrowClick() {
      this.$emit('click')
    }
  }
}
</script>
<style lang="less">
.kye-report-arrow {
  font-size: 12px;
}
.layout-report-new-up {
  color: #1BC467;
}
.layout-report-new-down {
  color: #FF5555;
}
</style>




// WEBPACK FOOTER //
// src/public/components/kye-report-form/card/common/arrow.vue